const api = 'http://hom.api.sgi.ms.gov.br/d0116/siriema-pesca-service/v1';
const apiViaCep = 'https://viacep.com.br/ws';
const siriema = "http://show.imasul.ms.gov.br";

export const environment = {
    production: false,
    ambiente: 'Homologação',
    login: api + '/usuarios/login', // POST
    manual: api + '/manual/arquivo', // GET
    usuarios: {
        save: api + '/usuarios/save', // POST
        getUsuarioById: api + '/usuarios/', // GET
        getUsuarioBrasileiro: api + '/usuarios/brasileiro/', //GET
        getUsuarioEstrangeiro: api + '/usuarios/estrangeiro/' //GET
    },
    autorizacoes: {
        save: api + '/autorizacoes/save', // POST
        update: api + '/autorizacoes/', // PUT
        delete: api + '/autorizacoes/', // DELETE
        getAutorizacaoById: api + '/autorizacoes/', // GET
        getAutorizacoesByIdUsuario: api + '/autorizacoes/list/', // GET
        getValorUFERMS: api + '/autorizacoes/uferms', //GET
        getModalidades: api + '/autorizacoes/modalidades', //GET
        getMunicipiosMS: api + '/autorizacoes/municipios', //GET
        getPdfBoleto: api + '/autorizacoes/download/boleto-pdf/', //GET
        getPdfBoletoNovaAba: api + '/autorizacoes/boleto-pdf/', //GET
        cancelarAutorizacao: api + '/autorizacoes/cancelar/', //GET,
        getPdfAutorizacao: api + '/autorizacoes/download/carteira-pdf/', //GET
        getPdfAutorizacaoNovaAba: api + '/autorizacoes/carteira/', //GET
    },
    viaCep: {
        getEnderecoByCep: apiViaCep + '/' // GET
    },
    teste: {
        getPdfTeste: api + '/teste/file/'
    },
    security:{
        client_id: 'secpesca',
        client_secret: '7d0bbaac-419d-412a-b84c-c19ad96f3664',
        token_url: 'https://hom.id.ms.gov.br/auth/realms/ms/protocol/openid-connect/token'
    },
    urlSiriema: siriema
};
